<template>
<!-- 立项数据 -->
  <div id="initiateData">
    <div id="right">
      <!-- 日期控件 -->
      <HeadControl :titleName="'立项数据'" ref="HeadControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl>
       <!--中间区域-->
       <div class="centerBox" >
          <div class="leftBox">
            <div class="numberBox">
               <div class="numberBoxSmall">
                  <div class="imgBox">
                    <img v-if="reportList.length" :src="reportList[0].itemIcon" alt="">
                  </div>
                  <div class="dataBox">
                    <div class="ChineseBox">{{legend[0]}}</div>
                    <div class="numBox" v-if="reportList.length">{{reportList[0].count}}<i>个</i></div>
                  </div>                
               </div>
            </div>
            <div class="individualBox">
               <div class="numberBoxSmall">
                  <div class="imgBox">
                    <img v-if="reportList.length" :src="reportList[1].itemIcon" alt="">
                  </div>
                  <div class="dataBox">
                    <div class="ChineseBox">{{legend[1]}}</div>
                    <div class="numBox" v-if="reportList.length">{{reportList[1].totalCount}}<i>人</i></div>
                  </div>                
               </div>              
            </div>
          </div>
          <div class="rightBox">
            <div id="ProjectPerformanceEharts" ref="ProjectPerformanceEharts"></div>
          </div>
       </div>
       <!-- 底部区域 -->
       <div class="bottonBox">
            <ProjectDataEcharts :screenWidth="screenWidth" :ProjectSourceDataList="ProjectSourceDataList" :ProjectTypeDataList="ProjectTypeDataList"></ProjectDataEcharts>
       </div>
    </div>
  </div>
</template>

<script>
import HeadControl from '@/components/HeadControl'
import ProjectDataEcharts from '@/components/ReportComponent/ProjectDataEcharts'
import * as Urls from '@/helper/Urls';
import {EchartsformatDate,checkDay} from '@/helper/VueHelper.js'

export default {
  components:{
    HeadControl,
    ProjectDataEcharts
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      orgCode:'',
      dataRange:[],
      ProjectSourceDataList:'', // 项目来源数据
      ProjectTypeDataList:'', // 项目类型数据
      ProjectPerformanceDataList:'', // 立项走势
      reportList:'',
      legend:'',
    };
  },
  mounted(){
    let _this = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        _this.screenWidth = window.screenWidth;
      })();
    }; 
  },
  methods:{
    init(){
      this.$refs.HeadControl.getDatas('month')
      this.$refs.HeadControl.getSysOrg()
    },
    // 获取组织架构ID
    changeVal(val) {
       this.orgCode = val;  
       this.getProjectSourceData()  
       this.getProjectTypeData()  
       this.getProjectPerformanceData()
    },
    changDate(val){
       this.dataRange=val
       this.getProjectSourceData()  
       this.getProjectTypeData()  
       this.getProjectPerformanceData()    
    }, 
    // 时间
    changePicker(val){
       this.dataRange = val
       this.getProjectSourceData()  
       this.getProjectTypeData()  
       this.getProjectPerformanceData()     
    },
    getOrgCode(){
        this.$refs.HeadControl.getSysOrg()
    },
    // 获取项目来源数据
    getProjectSourceData(){
        let _this = this
        let url = Urls.getEchartsInitiateReportDataBySource
        let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'PROJECT-TYPE'
        }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
          _this.ProjectSourceDataList = server_data.data 
        })
    }, 
    // 获取项目类型
    getProjectTypeData(){
      let _this = this
      let url = Urls.getEchartsInitiateReportDataByType
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'PROJECT-TYPE'        
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
          _this.ProjectTypeDataList = server_data.data
        })      
    },
    // 获取立项走势
    getProjectPerformanceData(){
      let _this = this
      let url = Urls.getEchartsInitiateReportDataByTrend
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'PROJECT-TYPE'        
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
          _this.ProjectPerformanceDataList = server_data.data
           _this.reportList = server_data.data.reportList
          _this.legend = server_data.data.legend
        })       
    },
    // 立项走势报表
    initChart(){
      let WidthPx = this.screenWidth
      let Chart1 = this.$echarts.getInstanceByDom(this.$refs.ProjectPerformanceEharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ProjectPerformanceEharts);
      }      
      const option = {
              textStyle: {
                fontFamily: 'PingFang-M'
              },  
                title:{
                  text: '立项走势',
                  top:'24',  
                  left:this.$route.query.identification ? '20' : '30',
                  textStyle:{
                    fontWeight:500,
                  }
                },      
                grid: {
                    left: this.$route.query.identification ? '52' :(WidthPx <= 1366 ? '65' : '65'),
                    right: this.$route.query.identification ? '48' : '50',
                    top:this.$route.query.identification ? '100' : '100',
                    bottom: this.$route.query.identification ? '25' : (WidthPx <= 1366 ? '50' : '50'),
                    // containLabel: true
                },
                tooltip: {
                    show: true,
                    trigger: "axis",  
                    formatter: function (params) {
                     let h = `<div>`;
                     params.forEach(item => {
                      if (item.seriesIndex == 0) {
                        h += `<div >${EchartsformatDate(item.axisValue)}</div>
                                <div><div>${item.marker}${item.seriesName}：${item.value}个</div>
                              `
                      } else {
                        if(params.length== 1 ){
                          h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                        }
                        h += `<div>${item.marker}${item.seriesName}：${item.value}人</div></div>`
                      }
                      });                        
                        return h;
                  }, 
                  axisPointer: {
                      lineStyle: {
                          color: '#DDDDDD',
                          type:'solid'
                      },
                  },                     
                },                
                legend: {
                    show: true,
                    x: this.$route.query.identification ? '140' : '200',
                    y: '26',
                    icon: 'circle',
                    itemGap: 25,
                    itemWidth:8,
                    itemHeight:7,
                    textStyle: {
                        color: '#666666',
                        height: 10,
                        rich: {
                          a: {
                            verticalAlign: 'middle',
                        },
                      }
                    },
                    data: this.ProjectPerformanceDataList.legend
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: 0,
                     axisLine: {
                      show: Math.max(...this.ProjectPerformanceDataList.series[0].data,...this.ProjectPerformanceDataList.series[1].data) == 0 ? true : false,
                      lineStyle: {
                      color: '#DDDDDD'
                      }                    
                    },
                  axisLabel: {
                    show:this.$route.query.identification ? false : true,
                    color: '#666666',
                    interval:WidthPx <=1366 || checkDay(this.dataRange) < 30 ? 'auto' : Math.ceil( this.ProjectPerformanceDataList.xAxis.data.length / 10),
                    // rotate: WidthPx <=1366 ? 30: 0,
                    // fontSize:12,
                  },
                  splitLine: {
                    show: Math.max(...this.ProjectPerformanceDataList.series[0].data,...this.ProjectPerformanceDataList.series[1].data) == 0 ? false : true,
                    lineStyle: {
                      color: '#DDDDDD',
                      type: 'solid'
                    }
                  },
                  axisTick: {
                    show: false
                  },
                    data: this.ProjectPerformanceDataList.xAxis.data
                }],
                yAxis: [{
                        type: 'value',
                        name: '数量(个)',
                        minInterval:1, // 个数显示一个,无小数点
                        // min: 0,
                        // max: Math.ceil(this.ProjectPerformanceDataList.reportList[0].count/10)*10,  
                        //  interval: 'auto',
                       show:Math.max(...this.ProjectPerformanceDataList.series[0].data, ...this.ProjectPerformanceDataList.series[1].data) == 0 ? false : true,
                       splitLine: {
                        show: Math.max(...this.ProjectPerformanceDataList.series[0].data,...this.ProjectPerformanceDataList.series[1].data) == 0 ? false : true,
                        lineStyle: {
                          color: '#DDDDDD',
                          type: 'solid'
                        }
                      },
                      axisLine: {
                        show: false
                      },
                      axisLabel: {
                        show: true,
                        // padding:[2,2,2,2],
                        textStyle: {
                          color: '#666666'
                        }
                       },
                      axisTick: {
                        show: false
                       },
                      // 坐标轴名称的文字样式
                     nameTextStyle: {
                       padding: [0,15,0,0],
                       color:'#666666'
                     },
                    },
                ],
                series: [{
                        name: this.ProjectPerformanceDataList.series[0].name,
                        type: 'line',
                        smooth:true,
                        symbolSize: 2,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                opacity: Math.max(...this.ProjectPerformanceDataList.series[0].data) == 0 ? 0 : 1,
                                color:'#5ebbff',
                                lineStyle: {
                                    color: "#5ebbff",
                                    width: 2,
                                    opacity: Math.max(...this.ProjectPerformanceDataList.series[0].data) == 0 ? 0 : 1,
                                },
                            }
                        },
                         areaStyle: {
                            normal: {
                                color:'#e6f5ff',
                            }
                        },
                        data: this.ProjectPerformanceDataList.series[0].data
                    },
                    {
                        name: this.ProjectPerformanceDataList.series[1].name,
                        type: 'line',
                        smooth:true,
                        stack: '总量',
                        symbolSize: 2,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                              opacity: Math.max(...this.ProjectPerformanceDataList.series[1].data) == 0 ? 0 : 1,
                                color: '#72d8c0',
                                lineStyle: {
                                    color: "#72d8c0",
                                    width: 2,
                                    opacity: Math.max(...this.ProjectPerformanceDataList.series[1].data) == 0 ? 0 : 1,
                                },
                            }
                        },
                         areaStyle: {
                            normal: {
                              color: '#cdedf2', 
                            }
                        },
                        data: this.ProjectPerformanceDataList.series[1].data
                    },
            
                ]
              };
        this.myChart1.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth - 21,
            };
            this.myChart1.resize(resize)
          } else {
            this.myChart1.resize()
          }
        })       
    }
  },
    watch:{       
    ProjectPerformanceDataList(){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })
      this.initChart()
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
#initiateData{
  #right{
    box-sizing: border-box;
    .centerBox{
      display: flex;
      margin-top: 0.29rem;
      box-sizing: border-box;
      .leftBox{
        width: 25%;
        height: 3.8rem;
        margin-right: 0.12rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius:0.1rem;
        padding:0 0.3rem;
        .numberBox{
          display: flex;
          align-items: center;
          width: 100%;
          height: 50%;
          border-bottom: 1px solid #f6f6f6;
          .numberBoxSmall{
            display: flex;
            align-items: center;
            margin-left: 0.62rem;
            .imgBox{
              height:0.75rem;
              width: 0.75rem; 
              margin-right: 0.83rem;                        
              background-color: #fff;
              img{
                height: 100%;
                width: 100%;
              }
            }
            .dataBox{
              .ChineseBox{
                color: #666666FF;
                font-size: 0.14rem;
              }
              .numBox{
                margin-top: 0.1rem;
                font-size: 0.26rem;
                color: #333333FF;
                  i{
                    font-size: 0.14rem;
                    font-style:normal;
                  }
              }
            }
          }
        }
        .individualBox{
          display: flex;
          align-items: center;          
          width: 100%;
          height: 50%;   
          .numberBoxSmall{
            display: flex;
            align-items: center;
            margin-left: 0.62rem;
            .imgBox{
              height:0.75rem;
              width: 0.75rem; 
              margin-right: 0.83rem;                        
              background-color: #fff;
              img{
                height: 100%;
                width: 100%;
              }
            }
            .dataBox{
              .ChineseBox{
                color: #666666FF;
                font-size: 0.14rem;
              }
              .numBox{
                color: #333333FF;
                margin-top: 0.1rem;
                font-size: 0.26rem;
                  i{
                    font-size: 0.14rem;
                    font-style:normal;
                  }
              }
            }
          }    
        }
      }
      .rightBox{
        width: 75%;
        height: 3.8rem;
        margin-left: 0.12rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
         #ProjectPerformanceEharts{
          width: 100%;
          height: 3.8rem;
         }
      }
    }
  }
}
@media screen and (max-width: 768px){
  #initiateData{
    #right{
      .centerBox{
        display: flex;
        flex-direction: column;
        margin-top: 0.12rem;
        padding: 0 0.12rem;
        .leftBox{
          box-sizing: border-box;
          width: 100%;
          padding: 0.2rem;
          margin-right: 0;
          border: none;
          .numberBox,.individualBox{
            justify-content: center;
          }
        }
        .rightBox{
          width: 100%;
          border: none;
          margin-left: 0;
          margin-top: 0.14rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  #initiateData{
    #right{
      .centerBox{
        .leftBox{
          justify-content: center;
          .numberBox{
            justify-content: center;
            .numberBoxSmall{
              margin-left:0;
                .imgBox{
                margin-right: 0.7rem;
               }
            }
          }
          .individualBox{
            justify-content: center;
            .numberBoxSmall{
              margin-left:0;
                .imgBox{
                margin-right: 0.7rem;
               }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 768px){
   #initiateData{
    .queryCondition {
      margin-bottom: 0;
    }
   }
}
</style>


// WEBPACK FOOTER //
// OperationaDataReportOne.vue?2a6f2e18